//import map from './legend/subjectlist'


import map from './map'
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Stamen from 'ol/source/Stamen';
import Feature from "ol/Feature";
import Polygon from 'ol/geom/Polygon';
import LineString from 'ol/geom/LineString';
import Point from 'ol/geom/Point';
import Select from 'ol/interaction/Select';
import View from 'ol/View';
import Legend from 'ol-ext/legend/Legend';
import LegendCtrl from 'ol-ext/control/Legend';
import {Stroke, Fill, Style, Icon, RegularShape, Circle, Text} from 'ol/style';
import Shadow from 'ol-ext/style/Shadow';
import FontSymbol from 'ol-ext/style/FontSymbol';

window.ol=new Object();
window.ol.style=new Object();
window.ol.Style=Style;
window.ol.style.Stroke=Stroke;
window.ol.style.Fill=Fill;
window.ol.style.Circle=Circle;
window.ol.style.RegularShape=RegularShape;
window.ol.style.Shadow=Shadow;
window.ol.style.FontSymbol=FontSymbol;
window.ol.geom=new Object();
window.ol.geom.Point=Point;

//if (window.species==undefined) window.species='sbarnacle';		
if (window.species==null) window.species='igreylag';		

  // Define a new legend
  var legend = new Legend({
    title: 'List of Birds',
	titleStyle: new Text({
		font: 'bold 26px sans-serif',
		fill: new Fill({
            		width: 2,
			color: 'red',
		}),
  	}),
	textStyle: new Text({
		font: 'bold 13px sans-serif',
		fill: new Fill({
            		width: 2,
			color: 'teal',
		}),
  	}),
  });

function getTestStyle(feature){
	return new Style();
};


  var legendCtrl = new LegendCtrl({ 
    legend: legend,
    collapsed: true,
  });
  map.addControl(legendCtrl);


  legend.on('select', function(e) {
	  window.s=e.item.get('style');
	  e.item.get('style').setFill();
	  console.log(e.item.get('title'));
	  console.log(e.item.get('name'));
//    if (e.index >= 0) {
//	    console.log((e.symbol ? 'You click on symbol: ':'You click on row: ')+e.item.get('name')+' ('+e.index+')');
if ((
	window.location.href=="http://robin-nuc/goosetracks/admin.html" ||
	window.location.href=="http://robin-nuc/goosedevel/admin.html" ||
	window.location.href=="http://goosenews.org/goosetracks/admin.html" ||
	window.location.href=="https://goosenews.org/goosetracks/admin.html" 
)
	&& e.symbol){
	    console.log('You click on the symbol: '+e.item.get('title'));
	$(".data").off('click');
	    $.ajax({url: "proxy.php/telemetry/deploy_admin/tag_id/"+e.item.get("name")}).done(function(response){
   $(".data").html(response);
	window.menu.show();
    });
    }
    else {
	    console.log('You click on the title: '+e.item.get('title'));
	    toggleLayer(e.item.get('title'));
	    //toggleLayer('Geese');
    }
  });


function addSVG(svg, scale) {
    legend.addItem({ 
      title: 'SVG icon', 
      typeGeom: 'Point',
      style: new Style({
        image: new Icon({
          src: svg || 'https://upload.wikimedia.org/wikipedia/commons/6/67/OpenLayers_logo.svg',
          scale: scale || .3
        })
      })
    });
  }


















  // Display the style on select
  var select = new Select({ hitTolerance: 3 });
//  map.addInteraction(select);

  select.on('select', function(e){
    var f = e.selected[0];
	  console.log(f);
    // Remove feature from select (to get its style back) BUG ol6 ?
    select.getFeatures().remove(f);
    $('.options .img').html('');
    if (f) {
      var img = Legend.getLegendImage({
        // given a style  and a geom type
        //style: f.getStyle() || getFeatureStyle(f),
        //typeGeom: f.getGeometry().getType()
        //
        // or given a feature //
        feature: f.clone(),
        style: getFeatureStyle
      });
      $('.options .img').append(img);
      $('#center').hide();
    } else {
      $('#center').show();
    }
    if (f) select.getFeatures().push(f);
  });

  // Add selection to legend  -- referred to on dom button
  function addToLegend() {
    var f = select.getFeatures().item(0);
    // Remove feature from select (to get its style back with ol6) 
    if (f) select.getFeatures().remove(f);
    legend.addItem({
      className: $('#center input').prop('checked') ? 'center': '',
      title: $('.options .row textarea').val(),
      // given a style  and a geom type
      style: f.getStyle() || getFeatureStyle(f),
      typeGeom: f.getGeometry().getType()
      
      // or given a feature 
      //feature: f
    });
    if (f) select.getFeatures().push(f);
  }

  // Style function
  function getFeatureStyle (feature) {
    var st= [];
    // Shadow style
    st.push (new ol.Style ({
      image: new ol.style.Shadow ({
        radius: 15
      })
    }));
    var st1= [];
    // Font style
    st.push ( new Style ({
      image: new ol.style.FontSymbol({
        form: "marker", 
        glyph: 'fa-car', 
        radius: 15, 
        offsetY: -15,
        fontSize: .7,
        color: '#fff',
        fill: new ol.style.Fill ({
          color: 'pink'
        }),
        stroke: new ol.style.Stroke ({
          color: '#fff',
          width: 2
        })
      }),
      stroke: new ol.style.Stroke ({
        width: 5,
        color: '#f00'
      }),
      fill: new ol.style.Fill ({
        color: [255, 0, 0, 0.6]
      })
    }));
    return st;
  }






//	$(window).on("load", function(){ legend.refresh(); vector.changed(); });

window.legendCtrl=legendCtrl;
window.legend=legend;
window.addToLegend=addToLegend;

module.exports.legend=legend;

